import { render, staticRenderFns } from "./TemplateReportBluForm.vue?vue&type=template&id=a4c119f6&"
import script from "./TemplateReportBluForm.vue?vue&type=script&lang=js&"
export * from "./TemplateReportBluForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports